import { Injectable } from '@angular/core';
import { ApiV6Service } from '@service/apiv6.service';
import { RequestTools } from '@service/request.tools';
import {
    currentRequest,
    setResultList,
    setinfoList,
    formatRequestBasket,
    setCurrentRequest,
    getlistColumns,
    concatAllBasket,
    fileConvertSize,
    getDelay,
    decodeUtf8,
    formatRequestCount,
    truncString,
    storeData,
    findItem,
} from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { reqBsk, reqWds, reqBas, doc_docid, reqIdx } from '@documalis/_const/const';
import { CheckTools } from './check.tools';
import { dateFormat } from '@core/_utils/date.utils';
import { TranslateService } from '@ngx-translate/core';
import { getBaskets } from '@core/_utils/basket.utils';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class Tools {
    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        private requestTools: RequestTools,
        private checkTools: CheckTools,
        private translate: TranslateService
    ) {}

    public async getDashStat(aNbDocs, aRequest) {
        let wRes;
        let wResB;
        let wResultRequest: any;
        let wResultDisplay: any;
        wRes = false;
        const wData = formatRequestCount(aNbDocs);
        wRes = await this.requestTools.execUrlAction(aRequest, wData);
        this.checkTools.checkError(wRes.data);
        if (this.checkTools.getRes() === false) {
            this._messageService.addErrorMsg(this.checkTools.getMsg());
            return {
                success: false,
            };
        }
        const wParams = this.prepareRequest(this.getDocId(wRes.data.data));
        wResB = await this.requestTools.execUrlAction('execrequestsearch', wParams);
        this.checkTools.checkError(wResB.data);
        if (this.checkTools.getRes() === true) {
            wResultRequest = wResB.data;
            wResultDisplay = this.verifyResult(wResultRequest);
            if (wResultDisplay !== undefined) {
                wResultDisplay = this.formatDataResult(wResultDisplay, reqIdx, null);
            } else {
                wResultDisplay = [];
            }
        } else {
            this._messageService.addErrorMsg(this.checkTools.getMsg());
            return {
                success: false,
            };
        }
        return {
            success: true,
            resultDisplay: this.addInfoAccess(wRes.data.data, wResultDisplay)
        }
    }

    private addInfoAccess(aLastDoc, aAccessDoc) {
        let wIndex = -1;
        return aLastDoc.map((item) => {
            wIndex = -1;
            wIndex = aAccessDoc.findIndex((elem) => {
                return elem.doc_docid === item.doc_docid;
            });
            if (wIndex !== -1) {
                item.acces = true;
            } else {
                item.acces = false;
            }
            return item;
        });
    }

    private getDocId(aList) {
        let wDocId: string;
        wDocId = '';
        aList.forEach((item) => {
            wDocId = wDocId + item.doc_docid + ',';
        });
        wDocId = truncString(wDocId, 1);
        return wDocId;
    }

    private prepareRequest(aValue) {
        let wRequest = {
            CountDoc: false,
            Search: {
                CriteriaList: [
                    { Criteria: { Name: doc_docid.name, FieldType: 'TextArea', OperatorType: 'TIn', Value: aValue } },
                ],
                ResultList: [
                    {
                        Criteria: {
                            Name: doc_docid.name,
                            FieldType: doc_docid.type,
                            Sort: doc_docid.sort,
                            SortType: doc_docid.typeorder,
                        },
                    },
                ],
            },
            requestid: -1,
        };
        return wRequest;
    }

    public async getBskDocList(
        aCurrentSelectedBsk,
        aEditorService,
        aVariableList,
        aBskListCount,
        aDelay,
        aEmptyField,
        aSearchWord,
        aTranslate,
        aResultList
    ) {
        let wRes: any;
        let wTranfert: any;
        let wresultDisplay: any;
        let wresultRequest: any;
        let wlistColumns: any[];
        let wnbDoc: number;
        let wbskVariableList: any[];
        let wbasketMoveAll: any[];
        let wresultList: any[];
        let winfoList: any[];
        let wcurrentRequest: currentRequest;
        let wDelay = null;
        let wIndex = -1;
        wresultDisplay = null;
        wlistColumns = null;
        wnbDoc = 0;
        wbskVariableList = null;
        wbskVariableList = [];
        wresultList = [];
        winfoList = [];

        if (aResultList.length !== 0) {            
            wresultList = [...wresultList,...aResultList];
        } else {
            wresultList = setResultList(aCurrentSelectedBsk);
        }
        // wresultList = setResultList(aCurrentSelectedBsk);
        // wresultList = [...wresultList,...aResultList];

        if (aResultList.length !== 0) {
            wIndex = findItem(wresultList, '&bsk_docdate', 'name');
            if (wIndex !== -1) {
                wresultList[wIndex].sort = aResultList.length;
            }
        }
        winfoList = setinfoList(wresultList);
        if (aCurrentSelectedBsk.bskType === 'btMail') {
            wDelay = aDelay;
        }
        let wRequest = formatRequestBasket(
            aEditorService,
            aVariableList,
            wresultList,
            false,
            aCurrentSelectedBsk.bskName,
            aCurrentSelectedBsk.bskTypeSearch,
            aCurrentSelectedBsk.bskModeAutoLock,
            aCurrentSelectedBsk.bskMaxShowDoc,
            aEmptyField,
            aSearchWord
        );
        wcurrentRequest = setCurrentRequest(reqBsk, wRequest);
        wlistColumns = getlistColumns(wresultList, aTranslate);

        try {
            wRes = await lastValueFrom(this.requestTools.getBasketDocListVar(
                wRequest,
                aCurrentSelectedBsk.bskTypeSearch,
                aCurrentSelectedBsk.bskName
            ));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant(error.error.CodeMessage));
            return { success: false};
        }
        if (wRes.getBskDocList.DocCount === '0') {
            this._messageService.addErrorMsg(this.translate.instant('NoDoc_Crit'));
            return {
                success: false,
            };
        }

        wresultDisplay = wRes.getBskDocList['DocumentList']['Document'];

        if (wRes.getBskVariableList !== undefined) {
            aEditorService.setMode(false);
            aEditorService.setBskVarListDef(wRes.getBskVariableList);
            wbskVariableList = JSON.parse(
                JSON.stringify(
                    aEditorService.formatVarList(
                        aEditorService.variableListService.execParse(wRes.getBskVariableList)
                    )
                )
            );
        }
        wTranfert = this.getBasketTransfert(wRes.getBskListByName, aBskListCount, false, null, null, null);
        wbasketMoveAll = concatAllBasket(
            wTranfert.wBasketMailList,
            wTranfert.wBasketCollectList,
            wTranfert.wBasketInputList,
            wTranfert.wBasketPublishList,
            );
        wresultDisplay = this.formatDataResult(wresultDisplay, reqBsk, wDelay);
        wresultDisplay = this.formatDisplayDate(wresultDisplay, wlistColumns);
        wnbDoc = wRes.getBskDocList['DocCount'];

        this.setDocks('', wRes.getDocks, aCurrentSelectedBsk.bskName);

        return {
            success: true,
            currentRequest: wcurrentRequest,
            listColumns: wlistColumns,
            bskVariableList: wbskVariableList,
            basketMoveAll: wbasketMoveAll,
            resultRequest: wresultRequest,
            resultDisplay: wresultDisplay,
            resultList: wresultList,
            infoList: winfoList,
            nbDoc: wnbDoc,
        };
    }

    public setDocks(aBaseName, aDocks, aBskName) {
        let wRequestData = {};
        if (aDocks.data.length !== 0) {
            wRequestData = {
                id: aDocks.data[0].id,                
                id_docks: aDocks.data[0].id_docks,
                docks: aDocks.data[0].docks,
                iddockuser: aDocks.data[0].iddockuser
            };
        } else {
            wRequestData = {
                id: 0,
                id_docks: 0,
                docks: aDocks.data,
                iddockuser: 0
            };
        }
        storeData(aBaseName + aBskName, JSON.stringify(wRequestData));
    }

    public async execSelectBasket(
        aUpdateFilter,
        aCurrentFilterAuto,
        aEditorService,
        aCurrentFilterId,
        aCurrentSelectedBsk,
        aCurrentIdReqentete,
        aVariableFilter,
        aVariableList,
        aBskListCount,
        aDelay,
        aEmptyField,
        aSearchWord,
        aTranslate,
        aResultList
    ) {
        let wRes: any;
        if (aUpdateFilter === true && aCurrentIdReqentete !== -1) {
            wRes = await this.requestTools.execSetUserBskFilter(
                aEditorService,
                aCurrentFilterId,
                aCurrentSelectedBsk.bskName,
                aCurrentIdReqentete,
                aVariableFilter,
                aCurrentFilterAuto
            );
        }
        wRes = await this.getBskDocList(
            aCurrentSelectedBsk,
            aEditorService,
            aVariableList,
            aBskListCount,
            aDelay,
            aEmptyField,
            aSearchWord,
            aTranslate,
            aResultList
        );
        return wRes;
    }

    public getFilterState(aDocCount, aSearchWord) {
        if (Number(aDocCount) !== 0 && aSearchWord !== '') {                
            return {                
                state: true,
                message: this.translate.instant('Srch_In_F')
            }
        } else {
            return {                
                state: false,
                message: this.translate.instant('Srch_In_1')
            }
        }
    }

    public verifyResult(resultRequest) {
        if (resultRequest['DocumentList'] === undefined || resultRequest['DocumentList'] === null) {
            return undefined;
        } else {
            return resultRequest['DocumentList']['Document'];
        }
    }

    public checkResult(aSuccess, aOrigin, aMsg) {
        let wResultRequest: any;
        let wResultDisplay: any;
        let wCurPage: number;
        let wNbDoc: number;
        let wIndex: number;
        let wDisplayCriteria = false;
        let wSuccess = true;
        this.checkTools.checkError(aSuccess);
        if (this.checkTools.getRes() === true) {
            wResultRequest = aSuccess;
            wResultDisplay = this.verifyResult(wResultRequest);
            if (wResultDisplay !== undefined) {
                try {
                    wResultDisplay = this.formatDataResult(wResultDisplay, aOrigin, null);
                    wCurPage = 1;
                    wNbDoc = wResultRequest['DocCount'];
                } finally {
                    wIndex = 1;
                    wDisplayCriteria = true;
                }
            } else {
                if (aMsg !== '') {
                    this._messageService.addWarnNoStick(aMsg);
                }
                wIndex = 0;
                wNbDoc = 0;
                wCurPage = 0;
            }
        } else {
            wIndex = 0;
            wSuccess = false;
            this._messageService.addErrorMsg(this.checkTools.getMsg());
        }
        return {
            success: wSuccess,
            resultRequest: wResultRequest,
            resultDisplay: wResultDisplay,
            curPage: wCurPage,
            nbDoc: wNbDoc,
            index: wIndex,
            displayCriteria: wDisplayCriteria,
        };
    }

    public async filterBasket(aBskName) {
        let wRes = true;
        let wResultFilter: any;
        let wUserBskFilter: any;
        let wListRequest: any;
        let wListResult: any;
        let wListDisplay: any;
        const wParams = {
            bskname: aBskName,
            filterAuto: 0,
        };
        wUserBskFilter = await this.requestTools.execUrlAction('getuserbskfilters', wParams);
        this.checkTools.checkError(wUserBskFilter);
        if (this.checkTools.getRes() === false) {
            this._messageService.addErrorMsg(this.checkTools.getMsg());
            wRes = false;
        } else {
            wResultFilter = this.requestTools.setResultFilter(wUserBskFilter.data);
            const formData = new FormData();
            formData.append('bskname', aBskName);
            wListRequest = await this.requestTools.getRequestListBasket(
                'getrequestsbyuserbsk',
                wResultFilter.currentIdReqentete,
                wResultFilter.currentFilterParam,
                formData
            );
            if (wListRequest.Status === 'ERROR') {
                this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
                wRes = false;
            }
            wListResult = await this.requestTools.getResultsList();
            if (wListResult.Status === 'ERROR') {
                this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
                wRes = false;
            }
        }
        try {
            const wdata = { basketname: aBskName };
            wListDisplay = await lastValueFrom(this.api.execUrlAction('getresfrombasket', wdata ));

        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            wRes = false;
        }
        return {
            res: wRes,
            resultFilter: wResultFilter,
            listRequest: wListRequest,
            listResult: wListResult.data.data,
            idxResult: wListDisplay['data'],
        };
    }

    public formatDataResult(resultDisplay, aOrigin, aDelay) {
        if (Array.isArray(resultDisplay) === false) {
            let warray = [];
            warray.push(resultDisplay);
            resultDisplay = [];
            resultDisplay = [...warray];
            warray = [];
        }
        return (resultDisplay = resultDisplay.map( (wresult) => {
            wresult.url = this.api.getThumb(wresult.doc_docid, 160);
            wresult.url320 = this.api.getThumb(wresult.doc_docid, 320);
            wresult.url800 = this.api.getThumb(wresult.doc_docid, 800);
            if (aOrigin !== reqWds) {
                wresult.doc_name = wresult.doc_name + wresult.doc_ext;
            }
            wresult = this.decodeData(wresult);
            if (wresult.doc_size) {
                wresult.doc_size = fileConvertSize(wresult.doc_size);
            }
            wresult.doc_page = parseInt(wresult.doc_page);
            if (aOrigin === reqBsk && aDelay !== null) {
                if (aDelay !== null) {
                    wresult.bsk_delay = getDelay(wresult.bsk_maillimit, aDelay);
                }
                wresult.bsk_mailactionLabel = this.translate.instant('Mail_'+parseInt(wresult.bsk_mailaction));
            }
            return wresult;
        }));
    }

    public formatDisplayDate(aListResult, aListCol) {
        if (aListResult !== null && aListResult !== undefined) {
            return aListResult.map((item) => {
                aListCol.forEach((col) => {
                    if (col.type === 'DateTime') {
                        if (item[col.field] === '') {
                            item[col.field] = item[col.field] + '|';
                        } else {
                            item[col.field] = item[col.field] + '|' + dateFormat(item[col.field], 'dd/MM/yyyy');
                        }
                    }
                });
                return item;
            });
        }
    }

    public getBasketTransfert(aData, aInfo, aFromGed, aListTag, aUserBskFilter, aDockDynList) {
        return getBaskets(aData, aInfo, aFromGed, aListTag, aUserBskFilter, this.api, aDockDynList);
    }

    public decodeData(data) {
        Object.keys(data).forEach((key) => {
            data[key] = decodeUtf8(data[key]);
        });
        return data;
    }

    public setTitleDetail(aSrchMode, aNbDoc) {
        let wTitle = '';
        if (aSrchMode === reqBas) {
            return this.getMsgCount(aNbDoc, false);
        } else {
            if (aSrchMode !== reqIdx && aNbDoc >= 1000) {
                wTitle = this.translate.instant('Limit');
            }
            return this.translate.instant('Result') + ' '  + this.getMsgCount(aNbDoc, true) + wTitle;
        }
    }

    public getMsgCount(anbdoc, atext) {        
        let wmsg = '';
        if (anbdoc <= 1) {
            wmsg = anbdoc + ' ' + this.translate.instant('Find_1')
        } else {
            let wNbdoc = anbdoc.toLocaleString(this.translate.instant('lang'))
            if (atext === true) {
                wmsg = wNbdoc + ' ' + this.translate.instant('Find_N');
            } else {
                wmsg = wNbdoc + ' ' + this.translate.instant('Find_D');
            }
        }
        return wmsg;
    }

    public getSelectdedCount(anbdoc) {
        let wmsg = '';
        if (anbdoc <= 1) {
            wmsg = anbdoc + ' ' + this.translate.instant('Sel_1');
        } else {
            wmsg = anbdoc + ' ' + this.translate.instant('Sel_N');
        }
        return wmsg;
    }

    public getCountDoc(adata) {
        let wnbDoc = 0;
        if (adata !== null) {
            wnbDoc = Number(adata['DocCount']);
        }
        return wnbDoc;
    }
}
